(function () {
  'use strict';

  /**
   * XModal
   */
  class XModal extends HTMLElement {
    constructor() {
      super();

      this.cancelButton = this.querySelector('.button--cancel');
      this.confirmButton = this.querySelector('.button--confirm');
    }
    connectedCallback() {
      this.cancelButton?.addEventListener('click', this._onCancel.bind(this));
      this.confirmButton?.addEventListener('click', this._onConfirm.bind(this));
    }
    _open() {
      this.classList.add('active');
    }
    _close() {
      this.classList.remove('active');
    }
    _onConfirm() {
      this._close();
    }
    _onCancel(e) {
      e.preventDefault();

      this._close();
    }
  }
  if (!window.customElements.get('x-modal')) {
    window.customElements.define('x-modal', XModal);
  }

  class CartDrawerDiscount extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.onApplyCouponListener = this._onApplyCoupon.bind(this);
      this.onRemoveCouponListener = this._onRemoveCoupon.bind(this);
    }
    connectedCallback() {
      this.button.addEventListener('click', this.onApplyCouponListener);
      document.querySelector('#remove-coupon')?.addEventListener('click', this.onRemoveCouponListener);
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.onApplyCouponListener);
      document.querySelector('#remove-coupon')?.removeEventListener('click', this.onRemoveCouponListener);
    }
    async _onApplyCoupon() {
      this._onApply(this.querySelector('input').value);
    }
    async _onRemoveCoupon() {
      this._onApply('null');
    }
    async _onApply(couponCode) {
      try {
        await fetch('/checkout?discount=' + couponCode).then((r) => r.text());

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('cart-drawer-discount')) {
    window.customElements.define('cart-drawer-discount', CartDrawerDiscount);
  }
})();
